// src/stone/illustrations/StonjiPhoneIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var StonjiPhoneIllustration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 80 80",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { fill: "#20252A", d: "M0 0h80v80H0z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00A868",
          d: "M60.051 14.998H19.985a4.96 4.96 0 0 0-4.96 4.959V80h4.982V24.97H60.03V80h4.977V19.957a4.96 4.96 0 0 0-4.955-4.96"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M60.033 24.965H20.007v55.03h40.026z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00A868",
          d: "M20.012 24.97a4.986 4.986 0 1 0 0-9.973 4.986 4.986 0 0 0 0 9.972M60.01 24.97a4.986 4.986 0 1 0 0-9.973 4.986 4.986 0 0 0 0 9.972"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M37.512 22.494a2.502 2.502 0 1 0 0-5.004 2.502 2.502 0 0 0 0 5.004"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M42.497 22.494a2.502 2.502 0 1 0 0-5.004 2.502 2.502 0 0 0 0 5.004"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M37.507 17.504v4.999h4.99v-5z" })
    ]
  }
);
var StonjiPhoneIllustration_default = StonjiPhoneIllustration;

export {
  StonjiPhoneIllustration,
  StonjiPhoneIllustration_default
};
